import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Account } from '../user-profile-details/client-data';
import { ApiService } from 'src/app/services/api.service';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { PhoneRequest } from 'src/app/models/requests';

@Component({
  selector: 'app-request-add-phone',
  templateUrl: './request-add-phone.component.html',
  styleUrls: ['./request-add-phone.component.scss']
})
export class RequestAddPhoneComponent implements OnInit {

  phoneForm: FormGroup;
  phoneRequest: PhoneRequest;
  isLoading: boolean = false;
  currentAccount: Account;
  accList: Account[] = [];
  
  constructor(
    public translate: TranslateService,
    private fb: FormBuilder,
    private _apiService: ApiService,
    private router: Router
  ) { }

  ngOnInit() {
    this.initForm();
    this.getRelationCode();
  }

  initForm() {
    this.phoneForm = this.fb.group({
      phoneNumber: ['', [Validators.required]]
    });
  }

  getRelationCode(){
    this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];
    this.currentAccount = this.accList[0];
  }

  submit(){
    if(this.phoneForm.valid) {
      this.phoneRequest = {
        RelationCode : this.currentAccount.relationCode,
        MainCode : 0,   
        Contact: this.phoneForm.get('phoneNumber')?.value,
        Verified: true
      };
      this.openConfirmationModal(this.phoneRequest);
    }
  }

  openConfirmationModal(phoneRequest) {
    const titleMessage = this.translate.instant("Confirm-Add_Phone_Request");

    const textConfirmMassage = `${this.translate.instant("Confirm-Add_Phone_Request_question")}`+"</br>"+
    `${this.translate.instant("order-rel-code")} : ${this.phoneRequest.RelationCode }`+"</br>"+
    `${this.translate.instant("clientName")} : ${this.translate.currentLang == "ar"? this.currentAccount.clientNameAr: this.currentAccount.clientNameEn}
    `+`${this.phoneRequest.Contact}`;


    Swal.fire({
      title: titleMessage,
      html:
        "<pre>" +
        textConfirmMassage +
        "</pre>" ,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: this.translate.instant("yes"),
      cancelButtonText: this.translate.instant("no"),
      reverseButtons: true,
    }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          this.AddPhoneRequest(phoneRequest);
        } else if (!result.isConfirmed) {
          this.isLoading = false;
        }
      });
  }

  AddPhoneRequest(requestDTO: PhoneRequest) {
    this._apiService.AddPhoneRequest(requestDTO)
    .subscribe(
      (res) => {
        this.isLoading = false;
        Swal.fire({
          position: "center",
          icon: "success",
          title: this.translate.instant("succes-msg"),
          showConfirmButton: false,
          timer: 4500,
        });
        this.router.navigate(['/requests-analysis/requests-table']);

      },
      (err) => {
        this.isLoading = false;
        Swal.fire({
          position: "center",
          icon: "error",
          title: this.translate.instant("error-msg"),
          showConfirmButton: false,
          timer: 4500,
        });
      }
    );
  }
}
